module.exports = __webpack_public_path__ + "img/contact8.3f14728f.png";